/**
Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MDInput from "components/MDInput";

// prop-types is a library for typechecking of props

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

const MDDatePicker = forwardRef(
  ({ label, name, value, format, onChange, slotProps, disabled, sx, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]} sx={{ marginTop: "-0.500rem" }}>
          <DatePicker
            {...rest}
            label={label}
            name={name}
            value={value}
            format={format}
            onChange={onChange}
            slotProps={slotProps}
            disabled={disabled}
            showDaysOutsideCurrentMonth
            sx={sx}
            renderInput={(params) => <MDInput {...params} />}
          />
        </DemoContainer>
      </LocalizationProvider>
    );
  }
);

// Setting default values for the props of MDDatePicker
MDDatePicker.defaultProps = {
  slotProps: {
    textField: {
      fullWidth: true,
      error: false,
      required: false,
      size: "small",
    },
    field: {
      clearable: true,
    },
  },
  sx: { width: "100%", height: "40px" },
  disabled: false,
};

export default MDDatePicker;
